import script from "./TariffNotificationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TariffNotificationModal.vue?vue&type=script&setup=true&lang=ts"

import "./TariffNotificationModal.vue?vue&type=style&index=0&id=10a9ac30&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10a9ac30"]])

export default __exports__